import axios from "axios";

import {
  attachAuthInterceptors,
  attachOptionalAuthInterceptor,
} from "./auth/authFailure";

const baseURL = window.env.TRADING_API_BASE_URL;

export const publicInstance = attachOptionalAuthInterceptor(
  axios.create({ baseURL }),
);
const instance = axios.create({ baseURL });

attachAuthInterceptors(instance);

export default instance;
